//#region src/types.ts
var e = /* @__PURE__ */ function(e) {
	return e.light = "white", e.dark = "#24272c", e;
}({});
//#endregion
export { e as ThemeColor };
